<template>
  <div class="px-4 w-full ">
    <div v-if="newReportForm">
      <form
        class="flex flex-col   space-y-2 "
        v-if="fields.length > 0"
        @submit.prevent="createReport()"
      >
        <div class="flex items-center justify-between">
          <div>
            <h2 class="text-2xl m-0 p-0 font-medium">{{ savedFormName }}</h2>
            <h2 class="text-2xl m-0 p-0 font-medium">Satır / Sütün</h2>
          </div>
          <svg
            @click="newReportForm = false"
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6 cursor-pointer"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"
            />
          </svg>
        </div>

        <div>
          <span class="text-xs">Rapor Türü</span>
          <button v-if="form.reportType === 'advanced' || form.reportType === 'advanced-list'" type="button" @click="showHelp('reportType')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
          <select class="uk-select" v-model="form.reportType">
            <option value="list">Liste</option>
            <option value="daily">Günlük matrix</option>
            <option value="monthly">Aylık matrix</option>
            <option value="yearly">Yıllık matrix</option>
            <option value="custom">Özel matrix</option>
            <option value="advanced">Gelişmiş Özet</option>
            <option value="advanced-list">Gelişmiş Liste</option>
          </select>
        </div>
        <div>
          <div class="flex space-x-2">
            <div>
              <span class="text-xs">Rapor Değer Gösterim Şekli</span>

              <select class="uk-select" v-model="form.valueType">
                <option value="COUNT">Adet</option>
                <option value="SUM">Toplam</option>
              </select>
            </div>

            <div v-if="form.valueType == 'SUM'">
              <span class="text-xs">Toplanacak değer</span>

              <select v-model="form.sumField" class="uk-select">
                <optgroup label="Mevcut Alanlar">
                  <option
                    v-for="field in fields"
                    :key="field.name"
                    :value="field.name"
                    >{{ field.display_name }}</option
                  >
                </optgroup>
                <optgroup label="İlişkili Alanlar">
                  <option
                    v-for="relation in relations"
                    :key="relation.id"
                    :value="relation.id"
                    >{{ relation.relation_name }}</option
                  >
                </optgroup>
              </select>
            </div>
          </div>
        </div>
        <div v-if="form.reportType != 'list' && form.reportType != 'advanced' && form.reportType != 'advanced-list'">
          <span class="text-xs">Satır Grupları</span>

          <select v-if="selectedTable" v-model="form.xaxis" class="uk-select">
            <optgroup label="Mevcut Alanlar">
              <option
                v-for="field in fields"
                :key="field.name"
                :value="field.name"
                >{{ field.display_name }}</option
              >
            </optgroup>
            <optgroup label="İlişkili Alanlar">
              <option
                v-for="relation in relations"
                :key="relation.id"
                :value="relation.id"
                >{{ relation.relation_name }}</option
              >
            </optgroup>
          </select>
        </div>

        <div v-if="form.reportType == 'list'" class="text-xs">
          <multiselect
            class="text-xs"
            v-model="form.ylistFields"
            :options="onlyFieldNames"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Seçiniz"
            label="display_name"
            track-by="name"
            :preselect-first="true"
          ></multiselect>
        </div>
        <div v-if="form.reportType == 'custom'">
          <div>
            <span class="text-xs">Sütün Grupları</span>
            <select v-if="selectedTable" v-model="form.yaxis" class="uk-select">
              <optgroup label="Mevcut Alanlar">
                <option
                  v-for="field in fields"
                  :key="field.name"
                  :value="field.name"
                  >{{ field.display_name }}</option
                >
              </optgroup>
              <optgroup label="İlişkili Alanlar">
                <option
                  v-for="relation in relations"
                  :key="relation.id"
                  :value="relation.id"
                  >{{ relation.relation_name }}</option
                >
              </optgroup>
            </select>
          </div>
        </div>
        <div class="flex items-center space-x-2">
              <label class="text-xs flex items-center space-x-2"><span>Sadece Aktif Kullanıcılar</span> <input type="checkbox" value="1"  v-model="form.onlyActiveUser" /></label>
            </div>

        <!-- Help Popup -->
        <div v-if="activeHelp && helpTexts[activeHelp]" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30" @click.self="closeHelp">
          <div class="bg-white rounded-lg shadow-xl p-4 max-w-md mx-4 relative">
            <button @click="closeHelp" class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl">&times;</button>
            <h4 class="font-semibold text-sm mb-2 text-blue-600">{{ helpTexts[activeHelp].title }}</h4>
            <div class="text-xs text-gray-700 leading-relaxed" v-html="helpTexts[activeHelp].text"></div>
          </div>
        </div>

        <!-- Advanced Report Configuration -->
        <div v-if="form.reportType == 'advanced'" class="border rounded p-4 bg-gray-50 space-y-4">
          <h3 class="text-sm font-semibold mb-2">Gelişmiş Özet Rapor Ayarları</h3>

          <!-- Group By -->
          <div>
            <span class="text-xs font-medium">Gruplama Alanı</span>
            <button type="button" @click="showHelp('groupBy')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs" title="Yardım">ⓘ</button>
            <select v-model="form.groupBy" class="uk-select">
              <option value="">Seçiniz</option>
              <optgroup label="Mevcut Alanlar">
                <option v-for="field in fields" :key="field.name" :value="field.name">
                  {{ field.display_name }}
                </option>
              </optgroup>
              <optgroup label="İlişkili Alanlar">
                <option v-for="relation in relations" :key="relation.id" :value="relation.id">
                  {{ relation.relation_name }}
                </option>
              </optgroup>
            </select>
          </div>

          <!-- Columns -->
          <div>
            <div class="flex items-center justify-between mb-2">
              <span class="text-xs font-medium">Sütunlar</span>
              <button type="button" @click="addAdvancedColumn()" class="text-xs bg-blue-500 text-white px-2 py-1 rounded">
                + Sütun Ekle
              </button>
            </div>

            <div v-for="(col, idx) in form.columns" :key="idx" class="border rounded p-3 mb-2 bg-white">
              <div class="flex items-start gap-2">
                <div class="flex-1 grid grid-cols-4 gap-2">
                  <div>
                    <span class="text-xs">Etiket</span>
                    <input v-model="col.label" type="text" class="uk-input text-xs" placeholder="TOTAL Deposit" />
                  </div>
                  <div>
                    <span class="text-xs">Tür</span>
                    <button type="button" @click="showHelp('columnType')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
                    <select v-model="col.type" class="uk-select text-xs">
                      <option value="aggregate">Agregasyon</option>
                      <option value="calculated">Hesaplanmış</option>
                    </select>
                  </div>
                  <div v-if="col.type === 'aggregate'">
                    <span class="text-xs">İşlem</span>
                    <button type="button" @click="showHelp('aggregation')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
                    <select v-model="col.aggregation" class="uk-select text-xs">
                      <option value="SUM">Toplam (SUM)</option>
                      <option value="COUNT">Adet (COUNT)</option>
                      <option value="COUNT_DISTINCT">Tekil Adet</option>
                      <option value="AVG">Ortalama (AVG)</option>
                    </select>
                  </div>
                  <div v-if="col.type === 'aggregate'">
                    <span class="text-xs">Alan</span>
                    <select v-model="col.field" class="uk-select text-xs">
                      <option value="*">* (Tümü)</option>
                      <option v-for="field in numericFields" :key="field.name" :value="field.name">
                        {{ field.display_name }}
                      </option>
                    </select>
                  </div>
                  <div v-if="col.type === 'calculated'" class="col-span-2">
                    <span class="text-xs">Formül</span>
                    <button type="button" @click="showHelp('formula')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
                    <input v-model="col.formula" type="text" class="uk-input text-xs" placeholder="total_deposit - wt" />
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <button type="button" @click="removeColumn(idx)" class="text-red-500 text-xs px-2 py-1 border rounded">
                    Sil
                  </button>
                </div>
              </div>

              <!-- Aggregate Filters -->
              <div v-if="col.type === 'aggregate'" class="mt-2 border-t pt-2">
                <div class="flex items-center justify-between mb-1">
                  <div class="flex items-center">
                    <span class="text-xs text-gray-600">Sütun Filtreleri</span>
                    <button type="button" @click="showHelp('columnFilters')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
                  </div>
                  <div class="flex items-center gap-2">
                    <label class="text-xs flex items-center gap-1 bg-yellow-50 px-2 py-0.5 rounded border border-yellow-200">
                      <input type="checkbox" v-model="col.abs" class="uk-checkbox" />
                      Mutlak Değer
                      <button type="button" @click="showHelp('absValue')" class="text-blue-500 hover:text-blue-700">ⓘ</button>
                    </label>
                    <label class="text-xs flex items-center gap-1 text-gray-400">
                      <input type="checkbox" v-model="col.negate" class="uk-checkbox" />
                      Negatif
                    </label>
                    <button type="button" @click="addColumnFilter(idx)" class="text-xs text-blue-500">+ Filtre</button>
                  </div>
                </div>
                <div v-for="(filter, fIdx) in col.filters" :key="fIdx" class="flex gap-2 mb-1">
                  <select v-model="filter.name" class="uk-select text-xs flex-1">
                    <option v-for="field in fields" :key="field.name" :value="field.name">
                      {{ field.display_name }}
                    </option>
                  </select>
                  <input v-model="filter.value" type="text" class="uk-input text-xs flex-1" placeholder="Değer" />
                  <button type="button" @click="removeColumnFilter(idx, fIdx)" class="text-red-500 text-xs">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Advanced List Report Configuration -->
        <div v-if="form.reportType == 'advanced-list'" class="border rounded p-4 bg-gray-50 space-y-4">
          <h3 class="text-sm font-semibold mb-2">Gelişmiş Liste Rapor Ayarları</h3>

          <!-- List Fields -->
          <div>
            <span class="text-xs font-medium">Liste Alanları</span>
            <button type="button" @click="showHelp('listFields')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
            <multiselect
              class="text-xs"
              v-model="form.advListFields"
              :options="fieldsWithRelation"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Seçiniz"
              label="display_name"
              track-by="name"
            ></multiselect>
          </div>

          <!-- Header Stats -->
          <div>
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center">
                <span class="text-xs font-medium">Header İstatistikleri</span>
                <button type="button" @click="showHelp('headerStats')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
              </div>
              <button type="button" @click="addHeaderStat()" class="text-xs bg-blue-500 text-white px-2 py-1 rounded">
                + İstatistik Ekle
              </button>
            </div>
            <div v-for="(stat, idx) in form.headerStats" :key="idx" class="border rounded p-2 mb-2 bg-white">
              <div class="grid grid-cols-4 gap-2">
                <div>
                  <span class="text-xs">Etiket</span>
                  <input v-model="stat.label" type="text" class="uk-input text-xs" placeholder="first ataması" />
                </div>
                <div>
                  <span class="text-xs">İşlem</span>
                  <select v-model="stat.aggregation" class="uk-select text-xs">
                    <option value="COUNT">COUNT</option>
                    <option value="COUNT_DISTINCT">COUNT_DISTINCT</option>
                    <option value="SUM">SUM</option>
                  </select>
                </div>
                <div>
                  <span class="text-xs">Alan</span>
                  <select v-model="stat.field" class="uk-select text-xs">
                    <option value="*">* (Tümü)</option>
                    <option v-for="field in fields" :key="field.name" :value="field.name">
                      {{ field.display_name }}
                    </option>
                  </select>
                </div>
                <div class="flex items-end">
                  <button type="button" @click="removeHeaderStat(idx)" class="text-red-500 text-xs px-2 py-1 border rounded">Sil</button>
                </div>
              </div>
              <div class="mt-2">
                <div class="flex items-center justify-between mb-1">
                  <span class="text-xs text-gray-600">Filtreler</span>
                  <button type="button" @click="addStatFilter(idx)" class="text-xs text-blue-500">+ Filtre</button>
                </div>
                <div v-for="(filter, fIdx) in stat.filters" :key="fIdx" class="flex gap-2 mb-1">
                  <select v-model="filter.name" class="uk-select text-xs flex-1">
                    <option v-for="field in fields" :key="field.name" :value="field.name">
                      {{ field.display_name }}
                    </option>
                  </select>
                  <input v-model="filter.value" type="text" class="uk-input text-xs flex-1" placeholder="Değer" />
                  <button type="button" @click="removeStatFilter(idx, fIdx)" class="text-red-500 text-xs">×</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Totals -->
          <div>
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center">
                <span class="text-xs font-medium">Footer Toplamları</span>
                <button type="button" @click="showHelp('footerTotals')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
              </div>
              <button type="button" @click="addFooterTotal()" class="text-xs bg-blue-500 text-white px-2 py-1 rounded">
                + Toplam Ekle
              </button>
            </div>
            <div v-for="(total, idx) in form.footerTotals" :key="idx" class="border rounded p-2 mb-2 bg-white">
              <div class="grid grid-cols-4 gap-2">
                <div>
                  <span class="text-xs">Etiket</span>
                  <input v-model="total.label" type="text" class="uk-input text-xs" placeholder="toplam çekim" />
                </div>
                <div>
                  <span class="text-xs">Alan</span>
                  <select v-model="total.key" class="uk-select text-xs">
                    <option v-for="field in fields" :key="field.name" :value="field.name">
                      {{ field.display_name }}
                    </option>
                  </select>
                </div>
                <div>
                  <span class="text-xs">İşlem</span>
                  <select v-model="total.aggregation" class="uk-select text-xs">
                    <option value="SUM">SUM</option>
                    <option value="COUNT">COUNT</option>
                  </select>
                </div>
                <div class="flex items-end">
                  <button type="button" @click="removeFooterTotal(idx)" class="text-red-500 text-xs px-2 py-1 border rounded">Sil</button>
                </div>
              </div>
            </div>
          </div>

          <!-- List Grouping (Müşteri Bazlı Gruplama) -->
          <div class="border-t pt-4 mt-4">
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center">
                <span class="text-xs font-medium">Müşteri Bazlı Gruplama</span>
                <button type="button" @click="showHelp('listGrouping')" class="ml-1 text-blue-500 hover:text-blue-700 text-xs">ⓘ</button>
              </div>
            </div>

            <!-- GroupBy Alanı -->
            <div class="mb-3">
              <span class="text-xs">Gruplama Alanı</span>
              <select v-model="form.listGroupBy" class="uk-select text-xs">
                <option :value="null">Gruplama Yok</option>
                <option v-for="field in fieldsWithRelation" :key="field.name" :value="field.name">
                  {{ field.display_name }}
                </option>
              </select>
            </div>

            <!-- Gruplama Sütunları -->
            <div v-if="form.listGroupBy">
              <div class="flex items-center justify-between mb-2">
                <span class="text-xs text-gray-600">Gruplama Sütunları</span>
                <button type="button" @click="addListGroupColumn()" class="text-xs bg-green-500 text-white px-2 py-1 rounded">
                  + Sütun Ekle
                </button>
              </div>
              <div v-for="(col, idx) in form.listGroupColumns" :key="idx" class="border rounded p-2 mb-2 bg-white">
                <div class="grid grid-cols-4 gap-2">
                  <div>
                    <span class="text-xs">Etiket</span>
                    <input v-model="col.label" type="text" class="uk-input text-xs" placeholder="Kalem Sayısı" />
                  </div>
                  <div>
                    <span class="text-xs">Alan</span>
                    <select v-model="col.field" class="uk-select text-xs">
                      <option value="*">* (Tümü)</option>
                      <option v-for="field in fields" :key="field.name" :value="field.name">
                        {{ field.display_name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <span class="text-xs">İşlem</span>
                    <select v-model="col.aggregation" class="uk-select text-xs">
                      <option value="COUNT">COUNT (Kalem Sayısı)</option>
                      <option value="COUNT_DISTINCT">COUNT_DISTINCT (Farklı Sayı)</option>
                      <option value="SUM">SUM (Toplam)</option>
                      <option value="AVG">AVG (Ortalama)</option>
                    </select>
                  </div>
                  <div class="flex items-end">
                    <button type="button" @click="removeListGroupColumn(idx)" class="text-red-500 text-xs px-2 py-1 border rounded">Sil</button>
                  </div>
                </div>
              </div>
              <p v-if="!form.listGroupColumns || form.listGroupColumns.length === 0" class="text-xs text-gray-500 italic">
                Sütun eklenmezse varsayılan olarak "Kalem Sayısı" gösterilecektir.
              </p>
            </div>
          </div>
        </div>


        <div class="flex space-x-2">
          <savebutton title="Oluştur" />
          <span
            @click="periodReportForm = !periodReportForm"
            class="global-button  cursor-pointer inline-flex"
            >Periyodik Rapor Oluştur</span
          >
          <span
            @click="saveReportForm = !saveReportForm"
            class="global-button  cursor-pointer inline-flex"
            >Raporu Farklı Kaydet</span
          >
          <span
            v-if="$root.cache.me.department == 'admin'"
            @click="updateReportForm = !updateReportForm"
            class="global-button  cursor-pointer inline-flex"
            >Raporu Güncelle</span
          >
          <span
            v-if="$root.cache.me.department == 'admin'"
            @click="chartForm = !chartForm"
            class="global-button  cursor-pointer inline-flex"
            >Chart ekle</span
          >
          <span
            @click="deleteReport()"
            v-if="$root.cache.me.department == 'admin'"
            class="global-button-red cursor-pointer   inline-flex"
            >Raporu sil</span
          >
        </div>
      </form>
    </div>
    <div v-else>
      <h2 v-if="savedFormName" class="text-2xl m-0  mb-2 p-0 font-medium">
        {{ savedFormName }}
      </h2>
      <span
        @click="newReportForm = !newReportForm"
        class="global-button  cursor-pointer inline-flex"
        >Değerleri değiştir</span
      >
    </div>
    <div v-if="chartForm">
      <form
        class="flex flex-col   space-y-2 "
        v-if="fields.length > 0"
        @submit.prevent="createReport()"
      >
        <div class="flex items-center justify-between">
          <h2 class="text-2xl m-0 p-0 font-medium">Chart ayarları</h2>
          <svg
            @click="chartForm = false"
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6 cursor-pointer"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"
            />
          </svg>
        </div>

        <div>
          <span class="text-xs">Rapor Türü</span>
          <select class="uk-select" v-model="form.chartSetting.type">
            <option value="pie">Pie</option>
            <option value="bar">Bar</option>
          </select>
        </div>
        <div>
          <div class="flex space-x-2">
            <div>
              <span class="text-xs">Rapor Değer Gösterim Şekli</span>

              <select class="uk-select" v-model="form.chartSetting.valueType">
                <option value="COUNT">Adet</option>
                <option value="SUM">Toplam</option>
              </select>
            </div>
            <div v-if="form.chartSetting.valueType == 'SUM'">
              <span class="text-xs">Toplanacak değer</span>

              <select v-model="form.chartSetting.sumField" class="uk-select">
                <optgroup label="Mevcut Alanlar">
                  <option
                    v-for="field in fields"
                    :key="field.name"
                    :value="field.name"
                    >{{ field.display_name }}</option
                  >
                </optgroup>
                <optgroup label="İlişkili Alanlar">
                  <option
                    v-for="relation in relations"
                    :key="relation.id"
                    :value="relation.id"
                    >{{ relation.relation_name }}</option
                  >
                </optgroup>
              </select>
            </div>
          </div>
        </div>
        <div>
          <span class="text-xs">Satır Grupları</span>

          <select
            v-if="selectedTable"
            v-model="form.chartSetting.xaxis"
            class="uk-select"
          >
            <optgroup label="Mevcut Alanlar">
              <option
                v-for="field in fields"
                :key="field.name"
                :value="field.name"
                >{{ field.display_name }}</option
              >
            </optgroup>
            <optgroup label="İlişkili Alanlar">
              <option
                v-for="relation in relations"
                :key="relation.id"
                :value="relation.id"
                >{{ relation.relation_name }}</option
              >
            </optgroup>
          </select>
        </div>

        <div v-if="form.chartSetting">
          <div>
            <span class="text-xs">Sütün Grupları</span>
            <select
              v-if="selectedTable"
              v-model="form.chartSetting.yaxis"
              class="uk-select"
            >
              <optgroup label="Mevcut Alanlar">
                <option
                  v-for="field in fields"
                  :key="field.name"
                  :value="field.name"
                  >{{ field.display_name }}</option
                >
              </optgroup>
              <optgroup label="İlişkili Alanlar">
                <option
                  v-for="relation in relations"
                  :key="relation.id"
                  :value="relation.id"
                  >{{ relation.relation_name }}</option
                >
              </optgroup>
            </select>
          </div>
        </div>
      </form>
    </div>
    <div v-if="saveReportForm" class="text-xs mt-4 border-t pt-4">
      <h3 class="text-2xl font-medium">Raporu Farklı Kaydet</h3>
      <form @submit.prevent="ReportSave()" class="flex  items-end space-x-2 ">
        <div>
          <span class="text-xs">Rapor başlığı</span>
          <input
            type="text"
            v-model="periodForm.name"
            class="w-full uk-input"
          />
        </div>

        <div class="">
          <span></span>
          <savebutton title="Kaydet" />
        </div>
      </form>
    </div>
    <div v-if="updateReportForm" class="text-xs mt-4 border-t pt-4">
      <h3 class="text-2xl font-medium">Raporu Güncelle</h3>
      <form
        @submit.prevent="ReportUpdate()"
        class="flex flex-1 w-full  items-end space-x-2 "
      >
        <div>
          <span class="text-xs">Rapor başlığı</span>
          <input
            type="text"
            v-model="periodForm.name"
            class="w-full uk-input"
          />
        </div>

        <div class="">
          <span></span>
          <savebutton title="Kaydet" />
        </div>
      </form>
    </div>
    <div v-if="periodReportForm" class=" text-xs mt-4 border-t pt-4">
      <h3 class="text-2xl font-medium">Periyodik rapor oluştur</h3>
      <form
        @submit.prevent="periodReportSave()"
        class="flex  items-end space-x-2 "
      >
        <div>
          <span class="text-xs">Rapor başlığı</span>
          <input type="text" v-model="periodForm.name" class="uk-input" />
        </div>
        <div>
          <span class="text-xs">İlk gönderim zamanı</span>
          <form-item
            class="flex-1"
            @changed="(g) => send_date_set(g)"
            :input="{
              name: 'next_send_date',
              display_name: 'Gönderilecek ilk zaman',
            }"
            :label="false"
            type="datetime"
          />
        </div>
        <div>
          <span class="text-xs">Periyot</span>
          <select class="uk-select" v-model="periodForm.period">
            <option value="30">Aylık</option>
            <option value="1">Günlük</option>
            <option value="7">Haftalık</option>
          </select>
        </div>
        <div class="flex-1">
          <span class="text-xs"
            >Raporun gönderileceği mail adresleri, birden fazla e-posta için
            aralarına virgül koyunuz</span
          >
          <input type="text" v-model="periodForm.receiver" class="uk-input" />
        </div>

        <div class="">
          <span></span>
          <savebutton title="Kaydet" />
        </div>
      </form>
      <div class="text-xs mt-2">
        Seçilmiş olan periyot ilk gönderim zamanından sonra başlar ve aynı saat
        diğer periyotlarda devam eder.
      </div>
    </div>

    <div class="mt-4">
      <div v-if="returnedValueCount > 0">
        <!-- Report Controls -->
        <div class="flex items-center justify-between mb-3 px-2 py-2 bg-gray-50 rounded border">
          <div class="flex items-center space-x-2">
            <button
              type="button"
              @click="toggleSidebar"
              class="px-3 py-1 text-xs bg-blue-500 hover:bg-blue-600 text-white rounded flex items-center space-x-1"
              title="Sidebar Gizle/Göster"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="9" y1="3" x2="9" y2="21"></line>
              </svg>
              <span>{{ sidebarVisible ? 'Sidebar Gizle' : 'Sidebar Göster' }}</span>
            </button>
          </div>

          <div class="flex items-center space-x-2">
            <span class="text-xs text-gray-600">Font Boyutu:</span>
            <button
              type="button"
              @click="decreaseFontSize"
              class="px-3 py-1 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded font-medium"
              title="Font Küçült"
            >
              A--
            </button>
            <span class="text-xs text-gray-600 min-w-[60px] text-center">{{ fontSize }}px</span>
            <button
              type="button"
              @click="increaseFontSize"
              class="px-3 py-1 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded font-medium"
              title="Font Büyüt"
            >
              A++
            </button>
          </div>
        </div>

        <div
          v-if="htmlReport"
          :style="{ maxWidth: sidebarVisible ? 'calc(100vw - 565px)' : 'calc(100vw - 100px)' }"
          class=" overflow-x-scroll rounded-lg border"
        >
          <div
            class="report-table"
            :style="{ fontSize: fontSize + 'px' }"
            ref="reportTable"
            @click="handleClick"
            v-html="htmlReport"
          ></div>
          <div
            v-if="form.reportType == 'list' || form.reportType == 'advanced' || form.reportType == 'advanced-list'"
            class="text-sm flex px-4 mb-4 space-x-2"
          >
            <div v-if="htmlReportTotal">
              Toplam Tutar : {{ htmlReportTotal }}
            </div>
            <div v-if="returnedValueCount">
              Toplam İşlem Sayısı : {{ returnedValueCount }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          v-if="form.reportType"
          class="flex flex-col items-center space-y-2"
        >
          <svg
            width="260"
            height="140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m188.93 118.333 19.063-12.415c2.031-1.317 3.263-3.562 3.247-5.949l-.147-24.706a6.8 6.8 0 0 0-3.32-5.803l-19.205-11.431c-2.27-1.351-5.146-1.29-7.404.165l-19.063 12.415c-2.031 1.318-3.263 3.562-3.247 5.949l.147 24.706a6.804 6.804 0 0 0 3.32 5.803l10.324 6.15 8.886 5.288c2.27 1.351 5.141 1.284 7.392-.167l.007-.005Z"
              stroke="#99A2AF"
              stroke-width="0.75"
              stroke-miterlimit="10"
            ></path>
            <path
              opacity="0.4"
              d="M200.101 76.66 187.169 85c-1.55.976-3.54 1.016-5.09.09l-8.26-4.918-1.786-1.063-3.395-2.018-3.126-1.864a1.515 1.515 0 0 1-.754-1.315 1.579 1.579 0 0 1 .735-1.35l9.411-6.135-.005.023 7.071-4.607c1.53-.993 3.539-1.034 5.088-.108l15.253 9.085h-.03l1.299.768c.678.405.754 1.102.762 1.388.003.28-.064.983-.743 1.414l-3.519 2.283.021-.014Z"
              stroke="#99A2AF"
              stroke-width="0.75"
              stroke-miterlimit="10"
            ></path>
            <g filter="url(#a)">
              <rect
                x="68.647"
                y="17"
                width="47.583"
                height="47.583"
                rx="9"
                transform="rotate(45 68.647 17)"
                stroke="#E16741"
                stroke-width="0.75"
              ></rect>
            </g>
            <rect
              opacity="0.4"
              x="68.647"
              y="24.764"
              width="36.602"
              height="36.602"
              rx="6"
              transform="rotate(45 68.647 24.764)"
              stroke="#E16741"
              stroke-width="0.75"
            ></rect>
            <path
              d="M71 44h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C63 46.28 63 47.12 63 48.801v4.398c0 1.68 0 2.521.327 3.163a3 3 0 0 0 1.311 1.311C65.28 58 66.12 58 67.8 58h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C75 55.72 75 54.88 75 53.2V48m-4-4v2.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C71.76 48 72.04 48 72.6 48H75m-4-4 2 2 2 2"
              stroke="#E16741"
              stroke-width="0.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M94 25.017c13.861-7.838 30.626-10.65 47.354-6.637 16.729 4.013 30.394 14.124 39.191 27.397"
              stroke="#E16741"
              stroke-width="0.5"
              stroke-linejoin="round"
              stroke-dasharray="4 4"
            ></path>
            <path
              opacity="0.5"
              d="M66.914 95c8.927 13.186 22.691 23.162 39.459 27.01 16.767 3.848 33.504.871 47.286-7.104"
              stroke="#99A2AF"
              stroke-width="0.5"
              stroke-linejoin="round"
              stroke-dasharray="4 4"
            ></path>
          </svg>
          <h2 class="text-lg font-semibold">
            Rapor oluşturulamadı
          </h2>
          <h6 class="text-sm">
            Kriterlerinize uyan bir rapor oluşturulamadı filtrede kullandığınız
            değerleri inceleyiniz.
          </h6>
        </div>
      </div>
    </div>
    <vk-modal class="editFormModal" size="container" :show.sync="modalShow">
      <template v-if="info">
        <h2 class="p-2 text-lg border-b mb-0">İşlem Detayı</h2>

        <table
          v-if="loading == false && infoResult.results"
          class="uk-table uk-table-hover deposit-table uk-table-middle uk-table-divider"
        >
          <tr>
            <th>İşlem No</th>
            <th class="">Temsilci</th>
            <th class="">Yatırımcı Adı</th>
            <th class="">Platform</th>
            <th class="">First Deposit</th>
            <th class="">Retention</th>
            <th class="">İşlem Türü</th>
            <th class="">İşlem Yöntemi</th>
            <th>Talep Edilen Miktar</th>
            <th>Platforma İşlenen Miktar</th>
            <th>Oluşturulma Tarihi</th>
            <th>Finans Onay / Red Tarihi</th>
            <th>Risk Onay / Red Tarihi</th>
            <th>Onay Durumu</th>
            <th>Aşama</th>
          </tr>
          <tr :key="trx.id" v-for="trx in infoResult.results">
            <td class="w-20">
              <div class="flex border rounded-lg bg-gray-50  items-center space-x-2   px-1">
                <a
                  :href="'/list/transactions?id=' + trx.id"
                  v-if="
                    $root.cache.me.department == 'admin' ||
                      $root.cache.me.department == 'sales_manager'
                  "
                  class="text-xs border-r pr-2 "
                  >Detay</a
                >
                <a class="text-xs" target="_blank" :href="'/leadDetail/'+trx.customer_id">Lead Detay</a>


              </div>
              <span class="text-xs">{{ trx.id }}</span>

            </td>
            <td class="w-20">{{ $root.getVal(15, trx.agent_id) }}</td>
            <td class="w-20">
              <template v-if="getleadInfo(trx.customer_id, 'name')">
                    {{ getleadInfo(trx.customer_id, "name") }}
                  </template>

            </td>

            <td class="w-20">{{ trx.login}}</td>
            <td class="w-20">
              <template v-if="getleadInfo(trx.customer_id, 'first_deposit_at')">
                    {{ getleadInfo(trx.customer_id, "first_deposit_at") }}
                  </template>

            </td>
            <td class="w-20">{{ $root.getVal(15, trx.retention_id) }}</td>
            <td class="w-20">{{ trx.type }}</td>
            <td class="w-20">{{ $root.getVal(199, trx.gateway_id) }}</td>
            <td class="w-20">
              {{ trx.amount }} {{ $root.getVal(148, trx.currency_id) }}
            </td>
            <td class="w-20">
              {{ trx.amount_platform }}
              {{ $root.getVal(148, trx.platform_currency_id) }}
            </td>
            <td class="w-40">
              <small>{{ trx.created_at }}</small>
            </td>
            <td class="w-40">
              <small>{{ trx.finance_approve_date }}</small>
            </td>
            <td class="w-40">
              <small>{{ trx.risk_approve_date }}</small>
            </td>
            <td class="w-40">
              <small v-if="trx.risk_approve_status == 1">Risk Onayladı </small>
              <small v-if="trx.finance_approve_status == 1"
                >Finans Onayladı</small
              >
            </td>
            <td class="w-40">
              <small>{{ $root.getVal(146, trx.status_id) }}</small>
            </td>
          </tr>
        </table>
      </template>
    </vk-modal>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import EventBus from "../components/Ui/EventBus";
import FormItemVue from "../components/Ui/FormItem";

import http from "../services/http";
export default {
  name: "reportMonthly",
  props: [
    "selectedTable",
    "filters",
    "fields",
    "relations",
    "savedForm",
    "savedFormName",
    "savedFormId",
    "sidebarVisible",
  ],
  components: {
    "form-item": FormItemVue,
    multiselect: multiselect,
  },
  data() {
    return {
      chartForm: false,
      modalShow: false,
      fontSize: 12,
      series: [44, 55, 13, 43, 22],
      chartOptions: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      data: [],
      filterz: [],
      periodForm: {},
      chartSettingForm: {},
      saveReportForm: false,
      updateReportForm: false,
      periodReportForm: false,
      loading: false,
      newReportForm: true,
      htmlReport: "",
      statusesModified: [],
      info: [],
      infoResult: [],
      savedReports: [],
      leadInfos: [],
      selectedFieldName: "utm_source",
      statuses: [],
      form: {
        chartSetting: {
          type: "pie",
        },
        groupBy: null,
        columns: [],
        advListFields: [],
        headerStats: [],
        footerTotals: [],
        listGroupBy: null,
        listGroupColumns: []
      },
      dates: [],
      formattedDate: [],
      returnedValueCount: 1,

      // Help System
      activeHelp: null,
      helpTexts: {
        reportType: {
          title: 'Rapor Türü',
          text: `<b>Gelişmiş Özet:</b> Verileri gruplar ve her grup için özet istatistikler gösterir. Örn: Satışçı bazlı yatırım/çekim raporu.<br><br>
                 <b>Gelişmiş Liste:</b> Detaylı liste + üstte özet istatistikler + altta toplamlar. Örn: Müşteri listesi raporu.`
        },
        groupBy: {
          title: 'Gruplama Alanı',
          text: `Verilerin nasıl gruplanacağını belirler.<br><br>
                 <b>Örnek:</b> "agent_id" seçerseniz her satışçı için ayrı satır görürsünüz.<br><br>
                 <b>İlişkili Alanlar:</b> ID yerine isim göstermek için bu bölümden seçin.`
        },
        columnType: {
          title: 'Sütun Türü',
          text: `<b>Agregasyon:</b> Matematiksel işlem yapar (SUM, COUNT, AVG).<br><br>
                 <b>Hesaplanmış:</b> Diğer sütunları kullanarak formül hesaplar.<br>
                 Örn: <code>total_deposit - wt</code>`
        },
        aggregation: {
          title: 'Agregasyon İşlemi',
          text: `<b>SUM:</b> Toplam değer<br>
                 <b>COUNT:</b> Kayıt sayısı<br>
                 <b>COUNT_DISTINCT:</b> Tekil kayıt sayısı (aynı değerler tek sayılır)<br>
                 <b>AVG:</b> Ortalama değer`
        },
        columnFilters: {
          title: 'Sütun Filtreleri',
          text: `Her sütun için özel filtre ekleyebilirsiniz.<br><br>
                 <b>Örnek:</b><br>
                 - <code>type = YATIRIM</code> → Sadece yatırımları toplar<br>
                 - <code>type = ÇEKİM</code> → Sadece çekimleri toplar<br>
                 - <code>status_id = 14</code> → Sadece onaylı işlemler<br>
                 - <code>first_fund = 1</code> → Sadece ilk fonlama`
        },
        absValue: {
          title: 'Mutlak Değer',
          text: `<b>ÇEKİM sütunlarında bu seçeneği aktif edin!</b><br><br>
                 Veritabanında çekimler negatif değer olarak saklanır (-1000 gibi).<br><br>
                 Bu seçenek negatif değerleri pozitife çevirir, böylece:<br>
                 - WT: 3,837,286 (pozitif gösterilir)<br>
                 - Net = Deposit - WT doğru hesaplanır`
        },
        formula: {
          title: 'Formül',
          text: `Diğer sütunların <b>key</b> değerlerini kullanarak hesaplama yapar.<br><br>
                 <b>Örnek:</b> <code>total_deposit - wt</code><br><br>
                 <b>Dikkat:</b> Kullandığınız key değerleri önceki sütunlarda tanımlı olmalı!<br>
                 Key değeri sütunun iç adıdır (etiket değil).`
        },
        headerStats: {
          title: 'Header İstatistikleri',
          text: `Raporun üstünde özet bilgiler gösterir.<br><br>
                 <b>Örnek çıktı:</b><br>
                 "150 müşteri / 89 fonlayan / 1,234,567 toplam yatırım"`
        },
        footerTotals: {
          title: 'Footer Toplamları',
          text: `Tablonun altında toplam satırı gösterir.<br><br>
                 <b>Örnek:</b><br>
                 - toplam yatırım: 1,234,567<br>
                 - toplam çekim: 456,789`
        },
        listFields: {
          title: 'Liste Alanları',
          text: `Tabloda gösterilecek sütunları seçin.<br><br>
                 <b>İpucu:</b> agent_id gibi ID alanları otomatik olarak ilişkili isme çevrilir.`
        },
        listGrouping: {
          title: 'Müşteri Bazlı Gruplama',
          text: `Verileri seçilen alana göre gruplar ve her grup için sayı/toplam gösterir.<br><br>
                 <b>Örnek:</b> customer_id seçildiğinde:<br>
                 - Müşteri A: 3 kalem, 5000₺<br>
                 - Müşteri B: 1 kalem, 1500₺<br><br>
                 <b>İpucu:</b> Sütun eklemezseniz varsayılan olarak "Kalem Sayısı" gösterilir.`
        }
      }
    };
  },
  computed: {
    onlyFieldNames() {
      return this.fields.map((e) => {
        return { display_name: e.display_name, name: e.name };
      });
    },
    numericFields() {
      return this.fields.filter(f =>
        f.name.includes('amount') ||
        f.name.includes('_id') ||
        f.type === 'number' ||
        f.type === 'decimal' ||
        f.type === 'integer' ||
        f.name.includes('count') ||
        f.name.includes('total')
      );
    },
    fieldsWithRelation() {
      // Alan listesine relation bilgisini de ekle
      return this.fields.map(f => {
        return {
          ...f,
          display_name: f.display_name || f.name,
          relation: this.guessFieldRelation(f.name)
        };
      });
    }
  },
  watch: {
    htmlReport() {
      this.$nextTick(() => {
        this.updateTableFontSize();
      });
    },
    fontSize(newVal) {
      this.$nextTick(() => {
        this.updateTableFontSize();
      });
    }
  },
  mounted() {
    EventBus.$on("modalClose", () => {
      this.modalShow = false;
    });
  },
  created() {
    if (this.savedForm) {
      this.newReportForm = false;
      this.form = this.savedForm;
    }
    this.periodForm.name = this.savedFormName;
    this.createReport();
  },
  methods: {
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    increaseFontSize() {
      if (this.fontSize < 24) {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize > 8) {
        this.fontSize -= 2;
      }
    },
    updateTableFontSize() {
      if (this.$refs.reportTable) {
        // CSS variable'ı güncelle
        this.$refs.reportTable.style.setProperty('--table-font-size', this.fontSize + 'px');

        // Tüm tablo elemanlarına inline style uygula
        const elements = this.$refs.reportTable.querySelectorAll('table, td, th, tr, tbody, thead, tfoot, span');
        elements.forEach(el => {
          el.style.setProperty('font-size', this.fontSize + 'px', 'important');
        });

        console.log('Font size updated to:', this.fontSize + 'px');
      }
    },
    getleadInfo(itemId, key) {
      const res = this.leadInfos.find((e) => e.id == itemId);
      if (res) {
        return res[key];
      } else {
        return false;
      }
      //   return this.leadInfos.find((e) => e.id == itemId)[key];
    },
    findDateFieldIndex(filters, dateFields) {
      return filters.findIndex((filter) => dateFields.includes(filter.name));
    },
    handleClick(event) {
      // Event'in gerçekleştiği elementi kontrol et
      const target = event.target;

      // form.filters yoksa boş array kullan
      this.filterz = this.form.filters ? [...this.form.filters] : [];

      const dateFields = [
      "created_at", "updated_at","last_activity", "last_note_date", "risk_approve_date", "finance_approve_date", "first_deposit_at", "last_deposit_at", "birthday", "customer_set_date","first_fund_date"
      ];

      if (target.tagName === "TD") {
        if (this.form.table == "transactions") {
          this.info = { item: target.getAttribute("data"), form: this.form };

          // Filtreyi filters dizisine ekle

          if (this.form.xaxis) {
            if (this.info.item.split("|")[0]) {
              this.filterz.push({
                type: 1,
                name: this.form.xaxis,
                budeger: 55,
                value: this.info.item.split("|")[0],
              });
            }
          }

          const dateIndex = this.findDateFieldIndex(this.filterz, dateFields);

          let gunAy = this.info.item.split("|")[1].split("-");

          if (this.form.reportType == "daily") {
            if (this.form.filters[dateIndex].name) {
              this.filterz.push({
                type: 1,
                name: "created_at",
                /*    name: this.form.filters[dateIndex].name,*/
                value: this.info.item.split("|")[1],
              });
            }
          } else {
            if (parseFloat(gunAy[0]) < 10) {
              this.filterz.push({
                type: 20,
                name: "created_at",
                value: "0" + this.info.item.split("|")[1],
              });
            } else {
              this.filterz.push({
                type: 20,
                name: "created_at",
                value: this.info.item.split("|")[1],
              });
            }
          }

          http
            .getData({
              table: this.form.table,
              filters: this.filterz,
              limit: 100,
            })
            .then((resp) => {
              this.infoResult = resp.data;


    Promise.all(
      this.infoResult.results.map((trx) => {
        return http.transaction.leadInfo(trx.customer_id, trx.id);
      })
    )
      .then((responses) => {
        this.leadInfos = [];

        responses.forEach((response) => {
          if (response.data.result.id) {
            this.leadInfos.push(response.data.result);
          }
        });
      });


            });




          this.modalShow = true;

        }
      }
    },
    deleteReport() {
      if (confirm("Rapor silinecek eminmisiniz ?")) {
        http
          .deleteReport({
            id: this.savedFormId,
          })
          .then((e) => {
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "success",
              title: "Başarılı",
              duration: 2000,
              body: "Başarılı bir şekilde rapor silindi",
            });
          });
        location.href = "/reports";
      }
    },
    showReport(data) {
      this.form = JSON.parse(data.report_values);
      this.selectedTable = this.form.table;
      // Eski raporlar için varsayılan değerler
      if (this.form.listGroupBy === undefined) {
        this.form.listGroupBy = null;
      }
      if (this.form.listGroupColumns === undefined) {
        this.form.listGroupColumns = [];
      }
      this.createReport();
    },
    send_date_set(a) {
      this.periodForm.next_send_date = a.value;
      this.$forceUpdate();
    },
    ReportUpdate() {
      http
        .updateReport({
          name: this.periodForm.name,
          id: this.savedFormId,
          report_values: this.form,
        })
        .then(() => {
          this.periodForm = {};
          EventBus.$emit("bottomMessage", {
            open: true,
            type: "success",
            title: "Başarılı",
            duration: 2000,
            body: "Başarılı bir şekilde rapor kaydedildi",
          });
        });
    },

    ReportSave() {
      http
        .saveReport({
          name: this.periodForm.name,
          report_values: this.form,
        })
        .then(() => {
          this.periodForm = {};
          EventBus.$emit("bottomMessage", {
            open: true,
            type: "success",
            title: "Başarılı",
            duration: 2000,
            body: "Başarılı bir şekilde rapor kaydedildi",
          });
        });
    },
    periodReportSave() {
      this.periodForm.data = this.form;
      this.periodForm.data = this.form;

      this.periodForm.status = 1;
      this.periodForm.type = 1;
      this.periodForm.table = this.form.table;
      http.savePeriodReport(this.periodForm).then((response) => {
        this.periodForm = {};
        EventBus.$emit("bottomMessage", {
          open: true,
          type: "success",
          title: "Başarılı",
          duration: 2000,
          body: "Başarılı bir şekilde periyodik rapor kaydedildi",
        });
      });
    },

    createReport() {
      if (this.selectedTable) {
        this.form.table = this.selectedTable.table;
        this.form.filters = this.filters;

        // Advanced List için listFields'ı dönüştür
        if (this.form.reportType === 'advanced-list' && this.form.advListFields) {
          this.form.listFields = this.form.advListFields.map(f => ({
            name: f.name,
            label: f.display_name || f.name,
            relation: f.relation || 0
          }));
        }

        if (this.form.reportType) {
          http.getReportMonthly(this.form).then((response) => {
            this.data = response.data.return;
            this.htmlReport = response.data.html;
            this.htmlReportTotal = response.data.total;

            this.returnedValueCount = response.data.count;
          });
        }
      }
    },

    // Help System Methods
    showHelp(key) {
      this.activeHelp = this.activeHelp === key ? null : key;
    },
    closeHelp() {
      this.activeHelp = null;
    },

    // Advanced Report Methods
    addAdvancedColumn() {
      if (!this.form.columns) {
        this.form.columns = [];
      }
      this.form.columns.push({
        key: 'col_' + Date.now(),
        label: '',
        type: 'aggregate',
        aggregation: 'SUM',
        field: 'amount_platform',
        filters: [],
        negate: false,
        abs: false,
        formula: ''
      });
    },

    removeColumn(idx) {
      this.form.columns.splice(idx, 1);
    },

    addColumnFilter(colIdx) {
      if (!this.form.columns[colIdx].filters) {
        this.form.columns[colIdx].filters = [];
      }
      this.form.columns[colIdx].filters.push({ name: '', value: '' });
    },

    removeColumnFilter(colIdx, filterIdx) {
      this.form.columns[colIdx].filters.splice(filterIdx, 1);
    },

    // Advanced List Report Methods
    addHeaderStat() {
      if (!this.form.headerStats) {
        this.form.headerStats = [];
      }
      this.form.headerStats.push({
        key: 'stat_' + Date.now(),
        label: '',
        aggregation: 'COUNT',
        field: '*',
        filters: []
      });
    },

    removeHeaderStat(idx) {
      this.form.headerStats.splice(idx, 1);
    },

    addStatFilter(statIdx) {
      if (!this.form.headerStats[statIdx].filters) {
        this.form.headerStats[statIdx].filters = [];
      }
      this.form.headerStats[statIdx].filters.push({ name: '', value: '' });
    },

    removeStatFilter(statIdx, filterIdx) {
      this.form.headerStats[statIdx].filters.splice(filterIdx, 1);
    },

    addFooterTotal() {
      if (!this.form.footerTotals) {
        this.form.footerTotals = [];
      }
      this.form.footerTotals.push({
        key: '',
        aggregation: 'SUM',
        label: ''
      });
    },

    removeFooterTotal(idx) {
      this.form.footerTotals.splice(idx, 1);
    },

    addListGroupColumn() {
      if (!this.form.listGroupColumns) {
        this.form.listGroupColumns = [];
      }
      this.form.listGroupColumns.push({
        field: '*',
        aggregation: 'COUNT',
        label: 'Kalem Sayısı',
        alias: 'col_' + Date.now()
      });
    },

    removeListGroupColumn(idx) {
      this.form.listGroupColumns.splice(idx, 1);
    },

    guessFieldRelation(fieldName) {
      // Bilinen ilişkili alanlar için relation ID'sini tahmin et
      const fieldRelationMap = {
        'agent_id': 15,
        'retention_id': 15,
        'retention_md_id': 15,
        'user_id': 15,
        'created_by_id': 15,
        'insert_agent_id': 15,
        'assigned_to': 15,
        'lead_status_id': 14,
        'customer_status_id': 14,
        'c_customer_status_id': 14,
        'status_id': 146,
        'currency_id': 148,
        'platform_currency_id': 148,
        'gateway_id': 199,
        'para_yatirma_yontemi': 199,
        'para_cekme_yontemi': 199,
        'team_id': 16,
        'user_group_id': 17,
        'note_status_id': 33,
        'file_category_id': 108,
        'whitelabel_id': 154,
        'country_id': 37,
      };
      return fieldRelationMap[fieldName] || 0;
    },
  },
};
</script>

<style>
.report-table,
.report-table table,
.report-table table td,
.report-table table th,
.report-table td,
.report-table th,
.report-table tr,
.report-table tbody,
.report-table thead,
.report-table span,
.report-table div,
.report-table * {
  font-size: inherit !important;
}

.report-table table td,
.report-table table th,
.report-table td,
.report-table th {
  padding: 8px 4px !important;
  margin: 0px !important;
  text-align: right;
}

.report-table table td,
.report-table td {
  font-weight: bold !important;
}

.report-table table th,
.report-table th {
  font-weight: 600 !important;
}
</style>
